import clsx from "clsx";
import { ReactNode } from "react";
import css from "./Button.module.css";

export function Button(props: {
  children: ReactNode;
  type?: HTMLButtonElement["type"];
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  color?: "green" | "yellow" | "gray" | "red";
}) {
  const color = props.color ?? "gray";
  const isDisabled = props.disabled || props.loading;

  return (
    <button
      type={props.type || "button"}
      className={clsx(css.button, css[color], props.loading && css.loading)}
      onClick={props.onClick}
      disabled={isDisabled}
    >
      <span
        className={css.wrapper}
        style={{ visibility: props.loading ? "hidden" : "visible" }}
      >
        {props.children}
      </span>
      {props.loading && <span className={css.spinner} />}
    </button>
  );
}
